<template>
  <div
    style="
      display: flex;
      margin-top: 25px;
      font-size: 14px;
      color: #666666;
      line-height: 40px;
    "
  >
    <!-- <div class="radioadd">
      <el-radio-group v-model="radiotype">
        <el-radio label="上传文件">上传文件</el-radio>
        <el-radio label="在线路是">在线录音</el-radio>
      </el-radio-group>
    </div> -->
    <div style="width: 100%">
      <div style="display: flex; width: 100%; font-size: 14px; color: #666666">
        <span class="imp">上传视频:&nbsp;</span>
        <el-upload
          v-loading="loadingfn"
          style="flex: 1"
          accept=".mp4"
          class="upload-demo"
          :show-file-list="false"
          drag
          action="#"
          multiple
          :http-request="customUploadfn"
          :on-change="handleChangefn"
          :before-upload="beforeUploadfn"
          :on-progress="handleProgressfn"
          :on-exceed="handleExceedfn"
          :auto-upload="true"
        >
          <svg
            style="margin-bottom: 10px"
            t="1754890564140"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5132"
            width="65"
            height="50"
          >
            <path
              d="M512 144c158.0544 0 288.2816 119.0912 305.8688 272.4352a228.096 228.096 0 0 1-21.9392 455.0912H228.096a228.0704 228.0704 0 0 1-21.9392-455.0912C223.744 263.0912 353.9456 144 512 144z m0.768 220.0832h-0.2048a36.352 36.352 0 0 0-25.9584 10.6752l-146.7648 146.7648a36.48 36.48 0 1 0 51.6096 51.6096l84.0704-84.0704v219.776a36.48 36.48 0 1 0 72.96 0v-220.928l85.2224 85.2224 0.4096 0.4096a36.48 36.48 0 0 0 51.2-52.0192l-146.7648-146.7648-0.4352-0.4096a36.352 36.352 0 0 0-25.344-10.2656z"
              fill="#4283F4"
              p-id="5133"
            ></path>
          </svg>
          <div class="el-upload__text">将视频拖到此处，或<em>点击上传</em></div>
          <div style="color: #999999; margin-top: -5px">
            视频时长不超过15秒，大小不超过20M，mp4格式
          </div>

          <!-- <div class="el-upload__tip" slot="tip">
                        只能上传jpg/png文件，且不超过500kb
                      </div> -->
        </el-upload>
      </div>
      <div v-if="fileName != ''">
        <span class="imp" style="visibility: hidden">上传视频:&nbsp;</span>
        <svg
          style="margin-right: 10px"
          t="1753700056245"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="5484"
          width="16"
          height="16"
        >
          <path
            d="M447.8976 228.096L297.5488 51.2h-170.24l150.3488 176.896h170.24z m442.1888 0L739.7376 51.2h-170.24l150.3488 176.896h170.24z m-221.1072 0L518.656 51.2h-170.24l150.3488 176.896h170.24zM954.1888 51.2h-163.584l150.3232 176.896h79.5904V117.504c0-37.5552-28.7488-66.304-66.304-66.304zM76.4672 51.2h-6.656C32.256 51.2 3.5328 79.9488 3.5328 117.504v110.592h223.2832L76.4672 51.2zM3.5072 957.696c0 37.5552 28.7232 66.304 66.304 66.304h884.3776c37.5808 0 66.3296-28.7488 66.3296-66.304V272.256H3.5072V957.696z m353.7408-486.4c0-37.632 30.9504-55.296 66.304-55.296 11.0848 0 24.32 2.2016 35.4048 8.8576l252.032 145.92a62.6432 62.6432 0 0 1 0 110.5408l-252.032 145.92c-11.0592 6.6304-22.1184 8.832-35.3792 8.832-35.3792 0-66.3296-17.664-66.3296-55.2704V471.296z"
            fill="#4384F4"
            p-id="5485"
          ></path></svg
        >{{ fileName }}
      </div>
      <div
        style="
          display: flex;
          margin-top: 25px;
          font-size: 14px;
          color: #666666;
          line-height: 40px;
        "
      >
        <span class="imp">输入问题:&nbsp;</span>
        <el-input
          v-model="quinput"
          placeholder="请输入视频问答问题"
          style="flex: 1"
        >
        </el-input>
      </div>
       <div
    
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: 14px;
                      color: #666666;
                      line-height: 40px;
                    "
                  >
                    <i style="visibility: hidden" class="imp">输入问题:&nbsp;</i>
                    <div class="submit" @click="subb" v-loading="subloading">
                  提交
                    </div>
                  </div>
      <!-- <div style="color: #999">
        <i style="visibility: hidden" class="imp">输入问题：</i
        ><svg
          t="1755064262478"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="6309"
          width="20"
          height="20"
        >
          <path
            d="M511.3 109.8c111.1 0 201.1 90.1 201.1 201.1v180.7c0 111.1-90.1 201.1-201.1 201.1s-201.1-90.1-201.1-201.1V310.9c0-111.1 90-201.1 201.1-201.1zM360.5 388.1v103.4c0 83.3 67.5 150.9 150.9 150.9s150.9-67.5 150.9-150.9V388.1H360.5z m0-50.2h301.7v-27c0-7.2-0.5-14.3-1.5-21.3H536.5c-13.9 0-25.1-11.3-25.1-25.1s11.3-25.1 25.1-25.1h107.7c-25.5-47.2-75.4-79.3-132.8-79.3-83.3 0-150.9 67.5-150.9 150.9v26.9z m176 453.6v72.6h150.9c13.9 0 25.1 11.3 25.1 25.1 0 13.9-11.3 25.1-25.1 25.1h-352c-13.9 0-25.1-11.3-25.1-25.1 0-13.9 11.3-25.1 25.1-25.1h150.9v-72.6c-155-12.8-276.7-142.5-276.7-300.7v-50.3c0-13.9 11.3-25.1 25.1-25.1s25.1 11.3 25.1 25.1v50.3c0 138.9 112.6 251.4 251.4 251.4s251.4-112.6 251.4-251.4v-50.3c0-13.9 11.3-25.1 25.1-25.1 13.9 0 25.1 11.3 25.1 25.1v50.3c0.3 158.2-121.5 287.9-276.3 300.7z"
            p-id="6310"
          ></path></svg
        >{{ fileListData.name }}
      </div> -->
    </div>
  </div>
</template>

<script>
import Recorder from "js-audio-recorder";
// import LAMP from 'lampjs';
// 正确方式（适用于 CommonJS 模块）
// import LAMP from "lampjs"; // 正确（如果 lampjs 是 ES6 模块）
import SparkMD5 from "spark-md5";
import CryptoJS from 'crypto-js';
export default {
  props: {
    subloading: false,

  },
  data() {
    return {
      // subloading:false,
      fileName: "",
      quinput: "",
      wavBlob: null,
      imgpath: "",
      loadingimg: false,
      radiotype: "上传文件",
      recorder: null,
      lamp: null,
      isRecording: false,
      audioUrl: null,
      audioBlob: null,
      recordingTime: 0,
      timer: null,
      volumeHeight: 10,
      recordText: '鼠标左键按住图标开始录制语音，时长不超过30秒',
      maxDuration: 30, // 最大录音时长（秒）
      fileListData: { name: "" },
      fileList: [],
      loadingfn: false,
      fileListfn: [], // 用于存储上传的文件列表
      uploadUrl: "", // 上传接口地址
      chunkSize: 1024 * 1024 * 5, // 分片大小，这里设为5MB
      uploading: false, // 是否正在上传
      totalChunks: 0, // 总分片数
      uploadedChunks: 0, // 已上传分片数
      fileurl:'',
      fileHash:''
    };
  },
  mounted() {
    // 初始化 LAMP（用于 WAV 转 MP3）
    // this.lamp = LAMP.someMethod()//new LAMP();
    console.log(this.lamp);
  },
  methods: {
    subb(){

      //  this.quinput ='视频的内容是什么'
      //  this.fileurl ='https://uac.t.educg.com/fileDownloadPDF.out?fid=689e94c21a78e143074abadf&ftype=video/mp4'
      if(this.fileurl==''){
    
         this.$message({
              message: '请上传视频',
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
        return;
      }
       if(this.quinput==''){
    
         this.$message({
              message: '请输入视频问答问题',
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
        return;
      }

      this.$emit('submitFun',{quinput:this.quinput,file:this.fileurl})
    },
        // 获取哈希值
    async calculateFileSHA256(file) {
      console.log('----------file',file)
   return new Promise((resolve, reject) => {
        if (!file) reject(new Error('No file provided'));
        
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                // 关键修复：将ArrayBuffer转换为WordArray
                const words = CryptoJS.lib.WordArray.create(
                    new Uint8Array(e.target.result) // 将ArrayBuffer转为Uint8Array
                );
                
                const hash = CryptoJS.SHA256(words).toString(CryptoJS.enc.Hex);
                resolve(hash);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = () => {
            reject(new Error('File read failed'));
        };
        reader.readAsArrayBuffer(file);
    });
      
    
    },
    /*****分片上传 */
    async customUploadfn(options) {
      console.log("optionsoptionsoptionsoptions");
      // if (this.fileListData.length > 3) {
      //   this.$message.error("最多只能上传3个文件");
      //   return;
      // }
      this.loadingfn = true;
      // this.fileList = [];
      const file = options.file;
      const isLargeFile = file.size > 3 * 1024 * 1024; // 30MB 分界线
     this.fileHash = await this.calculateFileSHA256(file)
      if (isLargeFile) {
        this.uploadLargeFilefn(file, options);
      } else {
        console.log("小");

        this.uploadSmallFilefn(file, options);
      }
    },
    uploadLargeFilefn(file, options) {
      console.log("filefilefile", file);
      const chunkSize = 3 * 1024 * 1024; // 每个分片大小为3MB
      const totalChunks = Math.ceil(file.size / chunkSize);
      let chunkIndex = 1;
      let uploadedChunks = 0;
      const chunks = [];
      const spark = new SparkMD5.ArrayBuffer();
      const reader = new FileReader();

      const updateProgress = (percent) => {
        options.onProgress({ percent: percent });
      };

      const readNextChunk = () => {
        //这里111
        const start = (chunkIndex - 1) * chunkSize;
        const end = Math.min(start + chunkSize, file.size);

        if (start >= file.size) {
          console.warn("无效分片范围");
          this.$message.warning("文件已读取完毕或分片范围无效");
          return;
        }

        const chunk = file.slice(start, end);
        reader.readAsArrayBuffer(chunk);
      };

      reader.onload = (e) => {
        const arrayBuffer = e.target.result;

        if (!arrayBuffer || arrayBuffer.byteLength === 0) {
          this.$message.error("读取分片失败");
          options.onError(new Error("空分片"));
          return;
        }

        spark.append(arrayBuffer);
        const fileMD5 = spark.end();
        const formData = new FormData();
        // formData.append("file", new Blob([arrayBuffer]));
        // formData.append("chunkIndex", chunkIndex);
        // formData.append("totalChunks", totalChunks);
        // formData.append("filename", file.name);

        formData.append("file", new Blob([arrayBuffer]));
        formData.append("blob_num", chunkIndex);
        formData.append("total_blob_num", totalChunks);
        formData.append("file_name", file.name);
        formData.append("md5", this.fileHash);
        formData.append("file_type", file.type);

        this.$axios
          .post( "/upload.do", formData)
          .then((res) => {
            if (res.status === 200) {
              chunks.push(res.data.chunkPath);
              uploadedChunks++;
              updateProgress(Math.round((uploadedChunks / totalChunks) * 100));
              //这里111
              if (chunkIndex < totalChunks && !res.data.name) {
                chunkIndex++;
                readNextChunk();
              } else {
                console.log("res", res);
                this.fileName = res.data.name;

                this.addchapter();
                this.loadingfn = false;
                options.onProgress({ percent: 0 });
                options.onSuccess(res);
              }
            }
              else{
                this.$message.error(res.data.msg || '异常');
            }
          })
          .catch((err) => {
            this.loadingfn = false;
            options.onError(err);
            this.$message.error("上传失败");
          });
      };

      reader.onerror = (errorEvent) => {
        const error = errorEvent.target?.error || "未知错误";
        this.$message.error(`文件读取失败: ${error.message}`);
      };

      readNextChunk();
    },
    handleChangefn(file, fileList) {
      this.fileListData = fileList.slice(-3);
      // this.fileListData[this.fileListData.length-1].fid = this.fileListfn[this.fileListData.length-1]
    },

    uploadSmallFilefn(file, options) {
      console.log("filefilefile", file);
      const reader = new FileReader();
      const spark = new SparkMD5.ArrayBuffer();
      const updateProgress = (percent) => {
        options.onProgress({ percent: percent });
      };
      reader.onload = (e) => {
        spark.append(e.target.result);
        const fileMD5 = spark.end();
        const formData = new FormData();
        formData.append("file", file);
        formData.append("blob_num", 1);
        formData.append("total_blob_num", 1);
        formData.append("file_name", file.name);
        formData.append("md5", this.fileHash);
        formData.append("file_type", file.type);

     this.$axios
          .post( "/upload.do", formData)
          .then((res) => {
            if (res.status === 200) {
              options.onSuccess(res);

              this.$message.success("上传成功");
              this.fileName = res.data.name;
              this.fileurl = res.data.view_url;//https://uac.t.educg.com/fileDownloadPDF.out?fid=689e94c21a78e143074abadf&ftype=video/mp4

              console.log("this.fileListData1111", this.fileList);
              this.addchapter();
              console.log("this.fid", this.fid);
              this.loadingfn = false;
            }
          })
          .catch((err) => {
            this.loadingfn = false;
            options.onError(err);
            this.$message.error("上传失败");
          });
      };
      reader.onerror = () => {
        this.loadingfn = false;
        this.$message.error("文件读取失败，无法生成MD5");
        options.onError(new Error("文件读取失败"));
      };

      reader.readAsArrayBuffer(file); // 开始读取文件以计算MD5
    },

    beforeUploadfn(file) {
      // 检查文件数量是否超过限制

      const isValidSize = file.size / 1024 / 1024 <= 30; // 小于30MB
      if (!isValidSize) {
        this.$message.error("文件大小不能超过30MB");
      }
      return isValidSize;
    },

    handleExceedfn(files, fileList) {
      console.log("this.fileListfn", fileList);
      if (this.fileList.length >= 3) {
        this.$message.warning('教学方案最多上传3个文件');
      }
    },

    handleProgressfn(event, file, fileList) {
      console.log("上传进度：", event.percent);
    },

    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      // if (this.fileList.length == 11) {
      //   this.$message.error("文件最多上传10个");
      //   return false;
      // }

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt2M;
    },
    // 开始录音
    async startRecording(e) {
      e.preventDefault(); // 防止移动端触屏事件冲突
      this.resetRecording();

      try {
        // 初始化录音器
        this.recorder = new Recorder({
          sampleBits: 16, // 采样位数
          sampleRate: 16000, // 采样率
          numChannels: 1, // 单声道
        });

        // 开始录音
        this.recorder.start().then(() => {
          this.isRecording = true;
          this.recordText = "";

          // 计时器
          this.timer = setInterval(() => {
            this.recordingTime++;
            if (this.recordingTime >= this.maxDuration) {
              this.stopRecording();
            }
          }, 1000);

          // 监听音量变化（用于动画）
          this.recorder.onprogress = (params) => {
            this.volumeHeight = Math.min(100, params.volume * 100);
          };
        });
      } catch (error) {
        console.error("录音启动失败:", error);
        this.$message.error("录音启动失败，请检查麦克风权限");
      }
    },

    // 停止录音（发送）
    stopRecording() {
      if (!this.isRecording) return;

      clearInterval(this.timer);
      this.isRecording = false;
      this.recordText = '鼠标左键按住图标开始录制语音，时长不超过30秒';

      // 停止录音
      this.recorder.stop();

      // 获取 WAV 格式音频
      const wavBlob = this.recorder.getWAVBlob();
      console.log(wavBlob);
      this.wavBlob = wavBlob;
      // this.transcribeAudio(wavBlob);

      // 转换为 MP3（可选）
      // this.convertToMP3(wavBlob);

      // 或者直接使用 WAV（如果不需要 MP3）
      // this.audioBlob = wavBlob;
      // this.audioUrl = URL.createObjectURL(wavBlob);
    },
    async transcribeAudio(audioFile) {
      const formData = new FormData();
      formData.append("file", audioFile);
      formData.append("model", "whisper-large:3");

      const response = await fetch(
        "https://prodsvc.educg.net/vllm-whisper-large-v3-serve/v1/audio/transcriptions",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer EMPTY",
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const completion = await response.json();
      console.log("completion.text", completion.text);
      return completion.text;
    },

    // 取消录音（上滑取消）
    cancelRecording() {
      if (!this.isRecording) return;

      clearInterval(this.timer);
      this.isRecording = false;
      this.recordText = '鼠标左键按住图标开始录制语音，时长不超过30秒';
      this.recorder.stop();
      this.$message.info("已取消录音");
    },

    // WAV 转 MP3
    convertToMP3(wavBlob) {
      const reader = new FileReader();
      let _this = this;
      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        _this.lamp.ready(() => {
          const mp3Blob = _this.lamp.encode(arrayBuffer);
          _this.audioBlob = mp3Blob;
          _this.audioUrl = URL.createObjectURL(mp3Blob);
        });
      };
      reader.readAsArrayBuffer(wavBlob);
    },

    // 发送录音
    sendAudio() {
      if (!this.audioBlob) return;

      // 1. 上传到服务器（示例）
      const formData = new FormData();
      formData.append("audio", this.audioBlob, "recording.mp3");

      // 2. 模拟上传（实际项目中替换为 API 调用）
      setTimeout(() => {
        this.$message.success("发送成功");
        this.resetRecording();
      }, 1000);
    },

    // 取消录音
    cancelAudio() {
      this.resetRecording();
      this.$message.info("已取消");
    },

    // 重置录音状态
    resetRecording() {
      this.isRecording = false;
      this.audioUrl = null;
      this.audioBlob = null;
      this.recordingTime = 0;
      this.volumeHeight = 10;
      clearInterval(this.timer);
    },
  },
};
</script>

<style scoped>
.voice-recorder {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  flex: 1;
      border-radius: 10px;
  border: 1px dashed #d5ddeb;
}

.record-btn {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  /* background: #409eff; */
  border: 1px solid #409eff;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); */
}

.record-btn:active {
  background: #f6fbff;
}

.recording-animation {
  margin-top: 20px;
  width: 100px;
  height: 50px;
  display: flex;
  align-items: flex-end;
  width: 100%;
}

.wave {
  width: 100%;
  background: #409eff;
  transition: height 0.1s;
}

.recording-tip {
  margin-top: 10px;
  color: #999;
}

.audio-preview {
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.audio-preview audio {
  margin-right: 10px;
}
.imp {
  width: 100px;
  display: inline-block;
  height: auto;
  background: transparent;
  margin-right: 0;
}
.en .imp{
      width: 126px;
}
.radioadd {
  position: absolute;
  top: -7px;
  right: 33px;
}
/deep/.el-upload__text {
  font-size: 14px;
  color: #4283f4;
}
/deep/.el-upload-dragger {
  border: 1px dashed #d5ddeb;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
/deep/.el-upload {
  width: 100%;
}
.imgpath:hover .imgset {
  display: flex;
}
.imgpath:hover .imgmask {
  display: block;
}
.imgmask {
  position: absolute;
  background: #000;
  opacity: 0.5;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
}
.imgset {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  display: none;
}
svg {
  vertical-align: sub;
}
.pf {
  background: rgb(82, 196, 116);
  width: 58px;
  padding: 0px 10px;
  color: #fff;
  border-radius: 6px;
  /* height: 22px; */
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  text-align: center;
}
.submit {
  background: #4384f4;
  color: #fff;
  height: 40px;
  line-height: 40px;
  text-align: center;
  flex: 1;
  /* margin-left: 20px; */
  border-radius: 6px;
  cursor: pointer;
      font-size: 16px;
}
@media screen and (max-width: 1600px) {
  .submit{
    font-size:14px;
  }
}

</style>